export default __webpack_public_path__ + "static/media/bnrimg.17664187.png";